<script setup>
import { ref, reactive, onMounted, onUnmounted, nextTick } from "vue";
import { userInfoStore, userTokenStore } from "@/store/store.js";
import rules from "@/utils/validator-rules.js";
import { ArrowRight } from "@element-plus/icons-vue";
import {
  changeNickname,
  changePassword,
  api_isBindWechat, updateClubRequireApproval, updateClubParticipantVisible, getClubInfo,
} from "@/api/club/settings.js";
import YTFormDialog from "@/components/YTFormDialog/index.vue";
import {userLogoutHooks} from "@/hooks/user.js"
import YTEditor from "@/components/YTEditor/index.vue";
import {formatTags} from "@/hooks/tag.js";
import YTTagSelect from "@/components/YTTagSelect/index.vue";
import YTGender from "@/components/YTGender/index.vue";
import {addAgreement, getAgreementCurrent} from "@/api/agreement/agreement.js";

onMounted(async () => {
  await handleGetClubConfig()
})

const userInfo = userInfoStore().info

// 处理获取俱乐部配置信息
const handleGetClubConfig = async () => {
  try {
    loading.value = true
    const res = await getClubInfo(account_info.storeId)
    clubConfig.clubId = res.clubId
    clubConfig.clubLogo = res.clubLogo
    clubConfig.clubName = res.clubName
    clubConfig.isWechatBound = res.isWechatBound
    clubConfig.participantVisible = res.participantVisible
    clubConfig.requireApproval = res.requireApproval
    clubConfig.userAvatar = res.userAvatar
    clubConfig.userNickname = res.userNickname
    clubConfig.userPhone = res.userPhone
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 俱乐部配置信息
const clubConfig = reactive({
  clubId: null,
  clubLogo: null,
  clubName: null,
  isWechatBound: false,
  participantVisible: false,
  requireApproval: false,
  userAvatar: null,
  userNickname: null,
  userPhone: ""
})

const account_info = reactive(JSON.parse(JSON.stringify(userInfoStore().info)));
const password_params = reactive({
  password: "",
  password_confirm: "",
  passwordOld: "",
});
const change_password_show = ref(false);
const change_nickname = ref(false);

const password_old_show = ref(false);
const password_show = ref(false);
const password_confirm_show = ref(false);

// 二维码弹窗
// 二维码弹窗状态
const open = ref(false);
// 缓存查看的二维码地址
const showQrCodeUrl = ref(null);
// 请求基地址
const url =
  import.meta.env.VITE_APP_ENV === "development"
    ? "https://dev.yttec.net/api"
    : import.meta.env.VITE_API_URL;
const appid =
  import.meta.env.VITE_APP_ENV === "development"
    ? "wx9117abc687d73792"
    : import.meta.env.VITE_WECHAT_APPID;

onUnmounted(() => {
  if (intervalId) clearInterval(intervalId);
  if (timeoutId) clearTimeout(timeoutId);
});

// 处理打开二维码动作
const handleOpenQrCode = (user) => {
  if (clubConfig.isWechatBound) return
  try {
    open.value = true;
    nextTick(() => {
      new WxLogin({
        self_redirect: true,
        id: `qrCodeDialog`,
        appid: appid,
        scope: "snsapi_login",
        redirect_uri: `${url}/admin/callback/creationAdminQrCallback/${
          userTokenStore().token.loginId
        }`,
        fast_login: 0,
        stylelite: 1,
      });
    });
  } catch (err) {
    console.log("err: ", err);
  }
};
// 关闭对话框
const closeDialog = () => {
  open.value = false;
  clearDialog();
  pollIsBindWechat();
};
// 清除对话框表单校验
const clearDialog = () => {
  showQrCodeUrl.value = null;
};

// 轮训微信绑定状态
let intervalId = null;
let timeoutId = null;

const pollIsBindWechat = () => {
  // 先清理可能存在的定时器，避免重复
  if (intervalId) clearInterval(intervalId);
  if (timeoutId) clearTimeout(timeoutId);

  // 立即执行一次
  isBindWechat();

  // 每1秒执行一次
  intervalId = setInterval(() => {
    isBindWechat();
  }, 1000);

  // 20秒后停止轮询
  timeoutId = setTimeout(() => {
    clearInterval(intervalId);
    intervalId = null;
    timeoutId = null;
  }, 20000);
};

// 查询微信绑定
const isBindWechat = async () => {
  try {
    const res = await api_isBindWechat();
    if (res) {
      const userInfo = userInfoStore();
      account_info.isBindWechat = true;
      userInfo.setInfo({
        username: account_info.username,
        nickname: account_info.nickname,
        email: account_info.email,
        avatar: account_info.avatar,
        adminId: account_info.adminId,
        tenantId: account_info.tenantId,
        storeId: account_info.storeId,
        storeType: account_info.storeType,
        isBindWechat: account_info.isBindWechat,
        bindWechatQrCode: account_info.bindWechatQrCode,
        phone: account_info.phone,
        storeLogo: account_info.storeLogo ?? "",
        storeName: account_info.storeName ?? "",
        loginType: account_info.loginType,
        hasActivityRegisterExtraInfo: account_info.hasActivityRegisterExtraInfo
      });
    }
  } catch (err) {}
};

const switchPassword = (type) => {
  if (type == 0) {
    password_old_show.value = !password_old_show.value;
  } else if (type == 1) {
    password_show.value = !password_show.value;
  } else if (type == 2) {
    password_confirm_show.value = !password_confirm_show.value;
  } else {
    return;
  }
};

// 裁剪账号昵称
const cutName = (name) => {
  console.log("name", name)
  if (!name) return ""
  return rules.isChinese(name.slice(0, 2))
    ? name.slice(0, 1)
    : name.slice(0, 2);
};

const saveNickname = async () => {
  try {
    if (clubConfig.userNickname === "" || clubConfig.userNickname === null) {
      ElMessage.warning("昵称不能为空");
      return;
    }
    if (clubConfig.userNickname.includes(" ")) {
      ElMessage.warning("昵称不能包含空格");
      return;
    }
    loading.value = true
    await changeNickname(clubConfig.userNickname);
    ElMessage.success("修改成功");
    // 重新请求信息
    const userInfo = userInfoStore();
    const res = await getClubInfo(account_info.storeId)
    clubConfig.clubId = res.clubId
    clubConfig.clubLogo = res.clubLogo
    clubConfig.clubName = res.clubName
    clubConfig.isWechatBound = res.isWechatBound
    clubConfig.participantVisible = res.participantVisible
    clubConfig.requireApproval = res.requireApproval
    clubConfig.userAvatar = res.userAvatar
    clubConfig.userNickname = res.userNickname
    clubConfig.userPhone = res.userPhone
    clubConfig.storeLogo
    clubConfig.storeName
    userInfo.setInfo({
      username: account_info.username,
      nickname: clubConfig.userNickname,
      email: account_info.email,
      avatar: clubConfig.userAvatar,
      adminId: account_info.adminId,
      tenantId: account_info.tenantId,
      storeId: account_info.storeId,
      storeType: account_info.storeType,
      isBindWechat: clubConfig.isWechatBound,
      bindWechatQrCode: account_info.bindWechatQrCode,
      phone: clubConfig.userPhone,
      storeLogo: account_info.storeLogo ?? "",
      storeName: account_info.storeName ?? "",
      loginType: account_info.loginType,
      hasActivityRegisterExtraInfo: account_info.hasActivityRegisterExtraInfo
    });
    change_nickname.value = false;
    loading.value = false
  } catch (e) {
    console.log(e);
    loading.value = false
  }
};

const savePassword = async () => {
  try {
    if (password_params.password != password_params.password_confirm) {
      ElMessage.warning("两次密码不相同");
      return;
    }
    if (
      password_params.password.includes(" ") ||
      password_params.password_confirm.includes(" ")
    ) {
      ElMessage.warning("密码不能包含空格");
      return;
    }
    const res = await changePassword(password_params);
    console.log("Res: ", res);
    ElMessage.success("修改成功");
    change_password_show.value = false;
    password_params.password = "";
    password_params.password_confirm = "";
    password_params.passwordOld = "";
    userLogoutHooks();
  } catch (e) {
    console.log(e);
  }
};

// 加载状态
const loading = ref(false);

// 处理会员申请加入俱乐部
const handleIsApproval = async (type) => {
  try {
    loading.value = true
    const storeId = account_info.storeId
    let param = {
      id: storeId,
      requireApproval: type
    }
    await updateClubRequireApproval(param)
    ElMessage.success("修改成功")
    loading.value = false
    await handleGetClubConfig()
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 处理活动是否展示报名人员名单
const handleIsVisible = async (type) => {
  try {
    loading.value = true
    const storeId = account_info.storeId
    let param = {
      id: storeId,
      participantVisible: type
    }
    await updateClubParticipantVisible(param)
    ElMessage.success("修改成功")
    loading.value = false
    await handleGetClubConfig()
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*活动协议配置相关功能*/
// 表单锚点
const ruleFormRef = ref()
// 表单信息
const agreementInfo = reactive({
  agreementName: null,
  agreementDescription: null
})
// 协议名称校验规则
const checkAgreementName = (rule, value, callback) => {
  if (!agreementInfo.agreementName) return callback(new Error("请输入协议名称"))
  return callback()
}
// 协议内容校验规则
const checkAgreementDescription = (rule, value, callback) => {
  console.log("YTEditorRef.value.getContentLength", YTEditorRef.value.getContentLength())
  if (YTEditorRef.value.getContentLength() === 0) return callback(new Error("请输入协议内容"))
  return callback()
}
// 表单校验规则
const agreementRules = {
  agreementName: [
    { validator: checkAgreementName, trigger: "blur" },
  ],
  agreementDescription: [
    { validator: checkAgreementDescription, trigger: "blur" }
  ]
}
// 弹窗打开状态
const openAgreement = ref(false)
// 协议弹窗加载状态
const agreementLoading = ref(false)
// 处理关闭活动协议配置
const handleDialogAgreementClose = () => {
  openAgreement.value = false
}
// 处理保存活动协议配置
const handleDialogAgreementSubmit = async () => {
  await ruleFormRef.value.validate(async (valid) => {
    // 处理富文本内容
    const res = await handleRich2Form();
    if (!res) throw new Errow("富文本描述过长");
    if (valid) {
      try {
        agreementLoading.value = true
        await ElMessageBox.confirm(
          '你已修改了会员在报名参加活动时需阅读并同意的协议内容，保存后原协议将被覆盖且不可恢复',
          '是否保存协议？',
          {
            confirmButtonText: '确定保存',
            cancelButtonText: '取消',
            confirmButtonClass: 'el-button--success',
            appendTo: '#app',
            closeOnClickModal: false,
            closeOnPressEscape: false
          }
        ).then(() => {
          addAgreement(agreementInfo)
          ElMessage.success("协议修改成功")
          openAgreement.value = false
        }).catch(() => {
          console.log("取消了修改协议")
          agreementLoading.value = false
        })
      } catch (e) {
        console.log(e)
        agreementLoading.value = false
      }
    } else {
      ElMessage.error("请根据提示修改表单信息");
    }
  })
}
// 富文本编辑器锚点
const YTEditorRef = ref();
// 处理自定义协议富文本赋值给表单
const handleRich2Form = async () => {
  console.log("赋值结果", YTEditorRef.value.getTxtTooLongState());
  if (YTEditorRef.value.getTxtTooLongState()) {
    ElMessage.error("自定义协议内容过长，描述内容请按规定照字数编写。");
    return false;
  }
  agreementInfo.agreementDescription = YTEditorRef.value.getTxt();
  return true;
};
// 处理活动相关介绍改变
const handleYTEditorChange = () => {
  ruleFormRef.value.validateField("agreementDescription")
}
// 打开编辑协议弹窗
const handleOpenAgreementDialog = async () => {
  try {
    openAgreement.value = true
    agreementLoading.value = true
    let param = {
      agreementType: "ACTIVITY"
    }
    const res = await getAgreementCurrent(param)
    agreementInfo.agreementName = res?.agreementName ?? null
    agreementInfo.agreementDescription = res?.agreementDescription ?? null
    agreementLoading.value = false
  } catch (e) {
    console.log(e)
    agreementLoading.value = false
  }
}
</script>

<template>
  <div class="settings bg_white br12" v-loading="loading">
    <div class="basic_info">
      <div class="title">账号基础信息</div>
      <div class="club_info flex_bt w-100">
        <div class="flex_left">
          <div class="club_avatar">
            <img :src="clubConfig?.clubLogo" />
          </div>
          <div class="club_name fs_16 ml28 fwb">
            {{ clubConfig?.clubName }}
          </div>
        </div>
        <div>
          <el-link :underline="false" href="/store/manageClub" v-if="userInfo.storeType === 'CLUB'">编辑资料</el-link>
        </div>
      </div>
    </div>
    <div class="account_info mt50">
      <div class="title">管理员账号资料</div>
      <div class="manager_info">
        <div class="avatar_name flex_bt">
          <div class="avatar_name_left flex_left">
            <div class="header_avatar">
              {{ cutName(clubConfig?.userNickname) }}
            </div>
            <div class="nickname_box ml23">
              <div class="nickname_box_title color_6F717D">昵称</div>
              <el-input
                class="mt10"
                style="width: 280px; height: 51px"
                v-model="clubConfig.userNickname"
                maxlength="10"
                placeholder=""
                @focus="change_nickname = true"
              ></el-input>
            </div>
          </div>

<!--          <div-->
<!--            v-if="change_nickname"-->
<!--            class="bg_4CAF50 color_fff p11_29 br12"-->
<!--            @click="saveNickname"-->
<!--          >-->
<!--            保存-->
<!--          </div>-->
          <v-btn v-if="change_nickname" style="box-sizing: border-box;padding: 0 30px;height: 37px;line-height: 37px;margin-right: 15px;" color="#4CAF50" @click="saveNickname">保存</v-btn>
        </div>
        <div class="phone flex_bt mt50">
          <div class="phone_left flex_left">
            <img src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/phone.svg" />
            <div class="phone_box_title color_6F717D fs_14 ml15">
              登录手机号
            </div>
          </div>

          <div class="phone fs_14">{{ clubConfig.userPhone.slice(0, 3)}}*****{{ clubConfig.userPhone.slice(-3)}}</div>
        </div>
        <div :class="[{'cursor-pointer': !clubConfig.isWechatBound}, 'bind_wechat', 'flex_bt', 'mt30', 'ml-20']" @click="handleOpenQrCode">
          <div class="bind_wechat_left flex_left">
            <img src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/bind.svg" />
            <div class="bind_wechat_title color_6F717D fs_14 ml15">
              绑定微信
            </div>
          </div>

          <div class="bind">
            <div v-if="clubConfig.isWechatBound">已绑定</div>
            <el-icon v-else color="#77788E">
              <ArrowRight />
            </el-icon>
          </div>
        </div>
        <div class="account_password flex_bt mt30">
          <div class="account_password_left flex_left">
            <img src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/account.svg" />
            <div class="account_password_title color_6F717D fs_14 ml15">
              账号密码
            </div>
          </div>
          <v-btn v-if="!change_password_show" style="box-sizing: border-box;padding: 0 30px;height: 37px;line-height: 37px;" color="#D7D7DF" @click="change_password_show = true">更换密码</v-btn>
          <div class="flex" v-if="change_password_show">
            <v-btn style="box-sizing: border-box;padding: 0 30px;height: 37px;line-height: 37px;margin-right: 15px;" color="#D7D7DF" @click="change_password_show = false">取消</v-btn>
            <v-btn style="box-sizing: border-box;padding: 0 30px;height: 37px;line-height: 37px;margin-right: 15px;" color="#4CAF50" @click="savePassword">保存</v-btn>
          </div>
        </div>
        <div class="change_password_box" v-if="change_password_show">
          <div class="change_password_item">
            <div class="change_password_txt">
              <text>*</text>
              当前密码
            </div>
            <div class="change_password_value">
              <el-input
                style="height: 51px"
                v-model="password_params.passwordOld"
                maxlength="16"
                placeholder=""
                :type="password_old_show ? 'text' : 'password'"
              >
                <template #suffix>
                  <span class="input_icon" @click="switchPassword(0)">
                    <img
                      v-if="password_old_show"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/hide.svg"
                      style="margin-right: 48px"
                    />
                    <img
                      v-else
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/show.svg"
                      style="margin-right: 48px"
                    />
                  </span>
                </template>
              </el-input>
            </div>
          </div>
          <div class="change_password_item">
            <div class="change_password_txt">
              <text>*</text>
              更换密码
            </div>
            <div class="change_password_value">
              <el-input
                style="height: 51px"
                v-model="password_params.password"
                maxlength="16"
                placeholder=""
                :type="password_show ? 'text' : 'password'"
              >
                <template #suffix>
                  <span class="input_icon" @click="switchPassword(1)">
                    <img
                      v-if="password_show"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/hide.svg"
                      style="margin-right: 48px"
                    />
                    <img
                      v-else
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/show.svg"
                      style="margin-right: 48px"
                    />
                  </span>
                </template>
              </el-input>
            </div>
          </div>
          <div class="change_password_item">
            <div class="change_password_txt">
              <text>*</text>
              确认新密码
            </div>
            <div class="change_password_value">
              <el-input
                style="height: 51px"
                v-model="password_params.password_confirm"
                maxlength="16"
                placeholder=""
                :type="password_confirm_show ? 'text' : 'password'"
              >
                <template #suffix>
                  <span class="input_icon" @click="switchPassword(2)">
                    <img
                      v-if="password_confirm_show"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/hide.svg"
                      style="margin-right: 48px"
                    />
                    <img
                      v-else
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/show.svg"
                      style="margin-right: 48px"
                    />
                  </span>
                </template>
              </el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="account_info mt50">
      <div class="title">会员管理功能</div>
      <div class="manager_info" v-loading="loading">
        <div class="join_club flex_bt ml-20">
          <div class="flex">
            <img src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/join_club.svg" />
            <div class="nickname_box_title color_6F717D fs_14 ml15">会员申请加入管理员审核</div>
          </div>
          <div class="tab_box">
            <div :class="clubConfig.requireApproval ? 'tab_item_active' : 'tab_item'" @click="handleIsApproval(true)">是</div>
            <div :class="clubConfig.requireApproval ? 'tab_item' : 'tab_item_active'" @click="handleIsApproval(false)">否</div>
          </div>
        </div>
        <div class="show_member_list_club flex_bt mt30 ml-20">
          <div class="flex">
            <img src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/show_member_list_club.svg" />
            <div class="nickname_box_title color_6F717D fs_14 ml15">支持会员查看活动报名人员名单（仅人数、头像和昵称）</div>
          </div>
          <div class="tab_box">
            <div :class="clubConfig.participantVisible ? 'tab_item_active' : 'tab_item'" @click="handleIsVisible(true)">是</div>
            <div :class="clubConfig.participantVisible ? 'tab_item' : 'tab_item_active'" @click="handleIsVisible(false)">否</div>
          </div>
        </div>
      </div>
    </div>
    <div class="account_info mt50">
      <div class="title">活动协议配置</div>
      <div class="manager_info" v-loading="loading">
        <div class="join_club flex_bt ml-20">
          <div class="flex">
            <img src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/settings_agreement.svg" />
            <div class="nickname_box_title color_6F717D fs_14 ml15">会员在报名参加活动时需阅读并同意的声明/协议</div>
          </div>
          <v-btn style="box-sizing: border-box;padding: 0 30px;height: 37px;line-height: 37px;" color="#D7D7DF" @click="handleOpenAgreementDialog">编辑协议</v-btn>
        </div>
      </div>
    </div>
  </div>
  <YTFormDialog
    id="dialog"
    :isPersistent="false"
    :open="open"
    :title="''"
    :max-width="400"
    style="text-align: center"
    @close="closeDialog"
  >
    <template v-slot:content="{ form }">
      <div class="tips_default">
        <img src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/wechat.svg" />
        <span class="ml10">微信扫码绑定</span>
      </div>
      <div
        id="qrCodeDialog"
        class="mg_0_auto"
        style="height: 200px; overflow: hidden"
      ></div>
    </template>
  </YTFormDialog>
  <el-dialog
      id="dialog"
      v-model="openAgreement"
      width="990"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div class="flex_bt">
        <div class="yt_dialog_title" style="padding-bottom: 30px"><span style="color: #f56c6c">*</span>活动协议配置</div>
      </div>
    </template>
    <div v-loading="agreementLoading" style="box-sizing: border-box;padding: 0 33px;">
      <el-form
          ref="ruleFormRef"
          :model="agreementInfo"
          :rules="agreementRules"
          style="height: 100%;width: 100%;"
      >
        <el-form-item label="协议名称：" prop="agreementName">
          <el-input v-model="agreementInfo.agreementName" maxlength="15" show-word-limit placeholder="请填写清晰的协议名称，最多15个字符内"></el-input>
        </el-form-item>
        <el-form-item prop="agreementDescription">
          <YTEditor
              :ali-oss-path="'GOODS_DETAIL_PATH'"
              ref="YTEditorRef"
              :max-pic-size="0"
              :title="'协议名称'"
              :maxLength="10000"
              :reviewTxt="agreementInfo.agreementDescription"
              @change="handleYTEditorChange"
              :is-show-upload="false"
          ></YTEditor>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <div class="yt_dialog_footer">
        <v-btn color="#d7d7df" variant="elevated" @click="handleDialogAgreementClose">取消</v-btn>
        <v-btn :disabled="agreementLoading" class="mg_l_2" color="#4CAF50" variant="elevated" @click="handleDialogAgreementSubmit">保存</v-btn>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
::v-deep(.el-input) {
  --el-input-focus-border-color: #796cb4;
  --el-input-border-radius: 15px;
  .is-focus {
    box-shadow: 0 0 0 1px var(--el-input-focus-border-color) inset !important;
  }
  .el-input__wrapper {
    height: 51px;
  }
}
.settings {
  box-shadow: 0 1px 5px 0 rgba(25, 24, 27, 0.22) !important;
  padding: 37px 0 233px 86px;

  .basic_info,
  .account_info {
    width: 80%;
    .title {
      font-size: 20px;
      font-weight: bold;
      text-align: left;
    }
    .club_info,
    .manager_info {
      box-shadow: 0px 1px 6px 0px rgba(25, 24, 27, 0.1);
      margin-top: 30px;
      padding: 27px 56px;
      border-radius: 15px;
      .club_avatar {
        img {
          width: 65px;
          height: 65px;
          border-radius: 50%;
        }
      }
      .nickname_box_title {
        text-align: left;
      }
      .bind_wechat {
        padding: 14px;
        border: 1px solid #e8e8e9;
        border-radius: 15px;
      }
      .join_club {

      }
      .show_member_list_club {

      }
      .tab_box {
        width: 134px;
        height: 37px;
        background: #D7D7DF;
        border-radius: 12px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        font-size: 14px;
        color: #222222;
        .tab_item {
          line-height: 30px;
          padding: 0 23px;
          border-radius: 8px;
        }
        .tab_item_active {
          line-height: 30px;
          padding: 0 23px;
          background: #FFFFFF;
          box-shadow: 0px 1px 6px 0px rgba(79,79,79,0.18);
          border-radius: 8px;
        }
      }
    }
    .bind {
      line-height: 16px;
      font-size: 14px;
    }
  }
  .header_avatar {
    width: 65px;
    height: 65px;
    background: #ebebeb;
    border-radius: 50%;
    font-weight: 500;
    font-size: 20px;
    color: #adabb0;
    line-height: 65px;
  }
  .change_password_box {
    margin-top: 22px;
    .change_password_item {
      display: flex;
      align-items: center;
      margin-top: 10px;
      .change_password_txt {
        width: 90px;
        font-size: 14px;
        color: #6f717d;
        text-align: right;
        text {
          color: #dc4c2f;
        }
      }
      .change_password_value {
        margin-left: 23px;
        flex: 1;
      }
    }
  }
}
.tips_default {
  font-size: 20px;
  color: #000;
  margin-bottom: 35px;

  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep(.el-link__inner:hover) {
  text-decoration: underline
}
</style>
